// src/hooks/nationalities/useGetNationality.js
import { useQuery } from "@tanstack/react-query";
import { getNationality } from "../../api/apiNationalities";

const QUERY_KEY = ["nationality"];

const useGetNationality = (id) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => getNationality(id),
    enabled: !!id,
  });

  return {
    isLoading,
    error: isError ? error : null,
    nationality: data?.data || null,
  };
};

export default useGetNationality;